import { render, staticRenderFns } from "./allSetting.vue?vue&type=template&id=03409510&scoped=true&"
import script from "./allSetting.vue?vue&type=script&lang=js&"
export * from "./allSetting.vue?vue&type=script&lang=js&"
import style0 from "./allSetting.vue?vue&type=style&index=0&id=03409510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03409510",
  null
  
)

export default component.exports